import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function Spinner({ className, size = "md" }: SpinnerProps) {
  return (
    <div
      className={cn(
        "border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin",
        size === "sm" && "w-4 h-4",
        size === "md" && "w-8 h-8",
        size === "lg" && "w-12 h-12",
        className
      )}
    />
  );
}

interface FullScreenLoaderProps {
  message: string;
  subMessage?: string;
}

export function FullScreenLoader({ message, subMessage }: FullScreenLoaderProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <Spinner size="lg" />
      <p className="text-lg font-medium text-gray-700">{message}</p>
      {subMessage && <p className="text-sm text-gray-500">{subMessage}</p>}
    </div>
  );
}
